function initVariantSelection() {
  const addToCartBtns = document.querySelectorAll(".m-add-to-cart");
  const buyOneClickWrappers = document.querySelectorAll(".buy-one-click");
  const variantSelects = document.querySelectorAll("select[name='id']");
  const variantRadios = document.querySelectorAll(".m-product-option__input");

  function updateButtons(hasSelection) {
    if (hasSelection) {
      addToCartBtns.forEach(btn => btn.classList.remove("is-disabled"));
      buyOneClickWrappers.forEach(wrapper => wrapper.classList.remove("is-disabled"));
    } else {
      addToCartBtns.forEach(btn => btn.classList.add("is-disabled"));
      buyOneClickWrappers.forEach(wrapper => wrapper.classList.add("is-disabled"));
    }
  }

  function syncSelection(selectedValue) {
    // Sync selects
    variantSelects.forEach(select => {
      if (select.value !== selectedValue) {
        select.value = selectedValue;
      }
    });

    // Sync radios
    variantRadios.forEach(radio => {
      radio.checked = radio.value === selectedValue;
    });

    updateButtons(!!selectedValue);
  }

  // Force all unselected at start
  variantSelects.forEach(select => (select.selectedIndex = 0));
  variantRadios.forEach(radio => (radio.checked = false));
  updateButtons(false);

  // Handle select changes
  variantSelects.forEach(select => {
    select.addEventListener("change", () => {
      syncSelection(select.value);
    });
  });

  // Handle radio changes
  variantRadios.forEach(radio => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        syncSelection(radio.value);
      }
    });
  });
}


function initDisabledButtonsModal() {
  const modal = document.getElementById("customModal");
  const closeBtn = document.querySelector(".custom-modal-close");

  // Handle Add to Cart clicks
  document.querySelectorAll(".m-add-to-cart").forEach(addToCartBtn => {
    addToCartBtn.addEventListener("click", e => {
      if (addToCartBtn.classList.contains("is-disabled")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        modal.style.display = "block";
      }
    });
  });

  // Handle Buy Now clicks
  document.querySelectorAll(".buy-one-click").forEach(buyNowWrapper => {
    const buyNowBtn = buyNowWrapper.querySelector("button");
    if (buyNowBtn) {
      buyNowBtn.addEventListener(
        "click",
        e => {
          if (buyNowWrapper.classList.contains("is-disabled")) {
            e.preventDefault();
            e.stopImmediatePropagation();
            modal.style.display = "block";
          }
        },
        true // capture
      );
    }
  });

  // Close modal
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
    });
  }

  window.addEventListener("click", e => {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
}

// ✅ Run on page load
document.addEventListener("DOMContentLoaded", () => {
  initVariantSelection();
  initDisabledButtonsModal();
});

document.addEventListener('click', function(e) {
    if (e.target.classList.contains('code_copy')) {
        e.preventDefault(); // Prevent page refresh

        const button = e.target;
        const wrapper = button.closest('.offer-wrapper');
        if (!wrapper) return;

        const descriptionElem = wrapper.querySelector('.offer-title p');
        if (!descriptionElem) return;

        const description = descriptionElem.innerText;

        navigator.clipboard.writeText(description).then(() => {
            const originalText = button.innerText;
            const originalColor = button.style.color;

            // Change button text and color
            button.innerText = 'Copied';
            button.style.color = '#28a745';

            // Revert after 2 seconds
            setTimeout(() => {
                button.innerText = originalText;
                button.style.color = originalColor;
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy!', err);
        });
    }
});



